import { usePlayerPortalsConfigContext } from '../contexts';
import { useMemo } from 'react';
import { redirectTo } from '@r-and-a-shared-ui/utils';

export const useChampionshipPicker = () => {
  const { siteSettings, currentChampionship } = usePlayerPortalsConfigContext();
  const availableChampionships = useMemo(() => {
    return siteSettings?.playerPortals?.availableChampionships; // TO DO: adapt to user context
  }, [siteSettings]);

  const redirectToChampionship = (champKontentCollection?: string) => {
    const foundChampionship = availableChampionships?.find(
      champ => champ.kontentCollection === champKontentCollection,
    );
    const url = `${foundChampionship?.website}/${
      foundChampionship?.landingPageLink?.href ?? ''
    }`;
    redirectTo(url);
  };

  return {
    currentChampionship,
    availableChampionships,
    methods: {
      redirectToChampionship,
    },
  };
};
